import { OptionSet } from './optionSet.model';

export class ArchivoCrm {
    IdProceso?: any;
    Docto1: boolean;
    Docto2: boolean;
    Docto3: boolean;
    Docto4: boolean;
    Docto5: boolean;
    Docto6: boolean;
    Docto7: boolean;
    Docto8: boolean;
    Docto9: boolean;
    Docto10: boolean;
    Docto11: boolean;
    Docto12: boolean;
    Docto13: boolean;
    Docto14: boolean;
    Docto15: boolean;
    Docto16: boolean;
    Docto17: boolean;
    Docto18: boolean;
    Docto19: boolean;
    Docto20: boolean;
    EstadoDocto1?: OptionSet;
    EstadoDocto2?: OptionSet;
    EstadoDocto3?: OptionSet;
    EstadoDocto4?: OptionSet;
    EstadoDocto5?: OptionSet;
    EstadoDocto6?: OptionSet;
    EstadoDocto7?: OptionSet;
    EstadoDocto8?: OptionSet;
    EstadoDocto9?: OptionSet;
    EstadoDocto10?: OptionSet;
    EstadoDocto11?: OptionSet;
    EstadoDocto12?: OptionSet;
    EstadoDocto13?: OptionSet;
    EstadoDocto14?: OptionSet;
    EstadoDocto15?: OptionSet;
    EstadoDocto16?: OptionSet;
    EstadoDocto17?: OptionSet;
    EstadoDocto18?: OptionSet;
    EstadoDocto19?: OptionSet;
    EstadoDocto20?: OptionSet;
    FechaDocto1?: any;
    FechaDocto2?: any;
    FechaDocto3?: any;
    FechaDocto4?: any;
    FechaDocto5?: any;
    FechaDocto6?: any;
    FechaDocto7?: any;
    FechaDocto8?: any;
    FechaDocto9?: any;
    FechaDocto10?: any;
    FechaDocto11?: any;
    FechaDocto12?: any;
    FechaDocto13?: any;
    FechaDocto14?: any;
    FechaDocto15?: any;
    FechaDocto16?: any;
    FechaDocto17?: any;
    FechaDocto18?: any;
    FechaDocto19?: any;
    FechaDocto20?: any;
    IdNota1: string;
    IdNota2: string;
    IdNota3: string;
    IdNota4: string;
    IdNota5: string;
    IdNota6: string;
    IdNota7: string;
    IdNota8: string;
    IdNota9: string;
    IdNota10: string;
    IdNota11: string;
    IdNota12: string;
    IdNota13: string;
    IdNota14: string;
    IdNota15: string;
    IdNota16: string;
    IdNota17: string;
    IdNota18: string;
    IdNota19: string;
    IdNota20: string;
}
